
import { useLocalStorage } from "src/utils/useLocalStorage"
import { useDebounce } from "src/utils/useDebounce"

interface UseSearchQueryReturn {
  /** The current search query value (updates immediately) */
  searchQuery: string
  /** The debounced search query value (updates after delay) */
  debouncedSearchQuery: string
  /** Function to update the search query */
  setSearchQuery: (value: string) => void
}

export const useSearchQuery = (): UseSearchQueryReturn => {
  const [searchQuery, setSearchQuery] = useLocalStorage<string>("dataSourcesSearchQuery", "")
  const debouncedSearchQuery = useDebounce(searchQuery, 500)

  return {
    searchQuery,
    debouncedSearchQuery,
    setSearchQuery
  }
}
